module.exports = __webpack_public_path__ + "img/check-list.c526e002.svg";